export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtSkladmistoost';
export const NAME = 'SkladoveMistoPredmetu';
